export const calculatePropNine = (formData = {}) => {
  const purchasePrice = parseCurrency(formData.purchasePrice);
  const salesPrice = parseCurrency(formData.salesPrice);

  if (purchasePrice <= 0 || salesPrice <= 0) {
    return zeroResult;
  }

  const assessedValue = parseCurrency(formData.loanInfoMeta?.assessedValueAmount);
  const caTaxRate = parseCurrency(formData.loanInfoMeta?.caTaxRate);
  const adjustedCashPercent = parseCurrency(formData.loanInfoMeta?.adjustedCashPercent);
  const inflationRate = parseCurrency(formData.loanInfoMeta?.inflationRate);

  // 0–365
  const adjustedCash365 = salesPrice * (adjustedCashPercent / 100);
  const diff365 = purchasePrice - adjustedCash365;
  const taxable365 = diff365 < 0 ? assessedValue : assessedValue + diff365;

  // 366–730
  const inflationFactor = salesPrice * inflationRate;
  const adjustedCash730 = inflationFactor * 1.1;
  const diff730 = purchasePrice - adjustedCash730;
  const taxable730 =
    diff730 < 0
      ? assessedValue * inflationRate
      : assessedValue * inflationRate + diff730;

  return {
    saleBetween365: {
      adjustedCash: toFixed2(adjustedCash365),
      diffSaleAndPurchase: toFixed2(diff365),
      taxableValue: toFixed2(taxable365),
      taxWithProp19: toFixed2(taxable365 * (caTaxRate / 100)),
      taxWithoutProp19: toFixed2(purchasePrice * (caTaxRate / 100)),
    },
    saleBetween730: {
      inflationFactor: toFixed2(inflationFactor),
      adjustedCash: toFixed2(adjustedCash730),
      diffSaleAndPurchase: toFixed2(diff730),
      taxableValue: toFixed2(taxable730),
      taxWithProp19: toFixed2(taxable730 * (caTaxRate / 100)),
      taxWithoutProp19: toFixed2(purchasePrice * (caTaxRate / 100)),
    },
  };
};

const zeroResult = {
  saleBetween365: {
    adjustedCash: "0.00",
    diffSaleAndPurchase: "0.00",
    taxableValue: "0.00",
    taxWithProp19: "0.00",
    taxWithoutProp19: "0.00",
  },
  saleBetween730: {
    inflationFactor: "0.00",
    adjustedCash: "0.00",
    diffSaleAndPurchase: "0.00",
    taxableValue: "0.00",
    taxWithProp19: "0.00",
    taxWithoutProp19: "0.00",
  },
};


const parseCurrency = (val) => {
  const n = Number(String(val ?? "").replace(/[^0-9.-]+/g, ""));
  return Number.isFinite(n) ? n : 0;
};

// Always returns STRING with 2 decimals (matches legacy behavior)
const toFixed2 = (val) => {
  const n = Number(val);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
};
